import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bankless',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bankless.component.html',
})
export class BanklessComponent {
  private router = inject(Router);
  public activeTab: 'dex' | 'passive' | 'aggressive' | '' = '';
  public passiveDropdownOpen = false;
  public mobileMenuOpen = false;
  public mobilePassiveOpen = false;

  launchDex() {
    this.activeTab = 'dex';
    this.passiveDropdownOpen = false;
    this.mobileMenuOpen = false;
    this.mobilePassiveOpen = false;
    this.router.navigate(['/']);
  }

  togglePassiveDropdown(event: Event) {
    event.stopPropagation();
    this.passiveDropdownOpen = !this.passiveDropdownOpen;
  }

  toggleMobileMenu(event: Event) {
    event.stopPropagation();
    this.mobileMenuOpen = !this.mobileMenuOpen;
    if (!this.mobileMenuOpen) {
      this.mobilePassiveOpen = false;
    }
  }

  closeDropdowns() {
    this.passiveDropdownOpen = false;
    this.mobileMenuOpen = false;
    this.mobilePassiveOpen = false;
  }

  navigateToPassive() {
    this.activeTab = 'passive';
    this.passiveDropdownOpen = false;
    this.mobileMenuOpen = false;
    this.mobilePassiveOpen = false;
    this.router.navigate(['/staking']);
  }

  navigateToYieldFarming() {
    this.activeTab = 'passive';
    this.passiveDropdownOpen = false;
    this.mobileMenuOpen = false;
    this.mobilePassiveOpen = false;
    this.router.navigate(['/yield-farming']);
  }

  navigateToAggressive() {
    this.activeTab = 'aggressive';
    this.passiveDropdownOpen = false;
    this.mobileMenuOpen = false;
    this.mobilePassiveOpen = false;
    this.router.navigate(['/liquidity']);
  }
}
